import { render } from "./BarcodeTest.vue?vue&type=template&id=19187530"
import script from "./BarcodeTest.vue?vue&type=script&lang=js"
export * from "./BarcodeTest.vue?vue&type=script&lang=js"
script.render = render

export default script